<template><div class="k-frameworks-category-card k-custom-border-color">
	<h2 class="k-fwcc-category-heading">
		<button
			type="button"
			class="k-fwcc-category"
			:id="category_button_id"
			:aria-expanded="String(contents_revealed)"
			:aria-controls="category_contents_id"
			:style="{ color: accessible_category_text_color }"
			@click="toggle_revealed"
		>
			<k-icon class="mr-2" color="primary" aria-hidden="true">fas fa-circle-chevron-{{contents_revealed?'down':'right'}}</k-icon>
			<span class="k-fwcc-category-text" v-html="cr.title"></span>
		</button>
	</h2>

	<k-expand-transition><div :id="category_contents_id" class="k-fwcc-docs" v-show="contents_revealed" role="region" :aria-labelledby="category_button_id">
		<FrameworkListFramework v-for="(fr, j) in cr.framework_records" :key="fr.lsdoc_identifier" v-if="rendered" v-show="cr.doc_showing[fr.lsdoc_identifier]" :framework_record="fr" :case_tree_lsdoc_identifier="case_tree_lsdoc_identifier" @view_framework="$emit('view_framework',$event)" />
		<!-- <k-spacer/> -->
	</div></k-expand-transition>
</div></template>

<script>
import { mapState, mapGetters } from 'vuex'
import goTo from 'vuetify/lib/services/goto'
import FrameworkListFramework from './FrameworkListFramework'

export default {
	components: { FrameworkListFramework, },
	props: {
		cr: { type: Object, required: true },
		case_tree_lsdoc_identifier: { type: String, required: true },
		search: { required: true },
	},
	data() { return {
		revealed_local: null,
		// this var, along with the logic below, prevents slow initial rendering of the categories when there are a lot of categories included in the site
		rendered: false,
		_observer: null,
	}},
	computed: {
		...mapState(['user_info', 'site_config']),
		accessible_category_text_color() {
			return U.get_accessible_text_color('#ffffff', this.site_config.sub_heading_color)
		},
		category_contents_id() {
			const raw_identifier = this.cr.category || this.cr.map_label || this.cr.title || 'group'
			const safe_identifier = String(raw_identifier).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '')
			return `framework-category-${safe_identifier || 'group'}`
		},
		category_button_id() {
			return `${this.category_contents_id}-button`
		},
		contents_revealed() {
			if (this.search) return true
			if (this.revealed_local !== null) return this.revealed_local
			// if the category hasn't been explicitly clicked, use default_revealed
			return this.default_revealed
		},
		default_revealed() {
			// if we have a "home category", default is showing for the home framework and hidden otherwise
			let home_category = this.$store.state.site_config.home_category
			if (home_category) {
				return this.cr.map_label == home_category
			}

			// otherwise default is hidden for a small screen, and showing otherwise
			return !this.$vuetify.breakpoint.smAndDown
		},
	},
	watch: {
		contents_revealed: {
			handler(val) {
				if (val) this.rendered = true
			}
		},
	},
	created() {
	},
	mounted() {
		if (this.contents_revealed) {
			// Category is expanded by default — defer tile rendering until the category scrolls near the viewport
			const observer = new IntersectionObserver((entries) => {
				if (entries[0].isIntersecting) {
					this.rendered = true
					observer.disconnect()
					this._observer = null
				}
			}, { rootMargin: '400px' })
			observer.observe(this.$el)
			this._observer = observer
		}
	},
	beforeDestroy() {
		if (this._observer) this._observer.disconnect()
	},
	methods: {
		toggle_revealed(val) {
			if (typeof(val) != 'boolean') {
				// if the category has never been explicitly clicked, set to the opposite of the default value
				if (this.revealed_local === null) val = !this.default_revealed
				else val = !this.revealed_local
			}
			if (val == true) this.rendered = true
			this.$nextTick(x=>this.revealed_local = val)
		},
	}
}
</script>

<style lang="scss">
.k-frameworks-category-card {
	border-top:1px solid #999;	// this color will be overwritten by site_config.dividing_line_color
	margin:20px 12px;
	padding:12px 0px 0 0;
	color:#222;
}

.k-frameworks-category-card:first-of-type {
	border:0!important;
	margin-top:0;
}

.k-fwcc-category {
	font-weight: bold;
	font-size:16px;
	line-height:18px;
	display:flex;
	align-items: center;
	cursor:pointer;
	width:100%;
	padding:0;
	border:0;
	background:none;
	text-align:left;
}

.k-fwcc-category-heading {
	margin:0;
}

.k-fwcc-category-text {
	flex:1 1 auto;
}

.k-fwcc-docs {
	margin-top:8px;
	display:flex;
	align-items: flex-start;
	justify-content: center;
	flex-wrap:wrap;
}

.k-fwcc-category:focus-visible {
	outline: none;
	box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.3);
	border-radius: 4px;
}

</style>
